import React from "react";

function BlogDetailsPage() {
  return <div>blogdetailspage</div>;
}

export default BlogDetailsPage;
